import * as React from 'react';

import styled from '@emotion/styled';
import { last } from 'lodash';

import { COLORS } from '@root/colors';
import { ISelection } from '@shared/components/files';

import { RateAdjustment__Upload__Product } from '@admin/schema';

import { FileUploader } from './file_uploader';

const Intro = styled.p`
  margin: 0 0 14px;
  font-size: 15px;
  line-height: 1.55;
  color: ${COLORS.grayDarker};
`;

export const Selector: React.FC<{ uploads: ISelection[]; product: RateAdjustment__Upload__Product }> = ({
  uploads,
  product,
}) => {
  const lowerProduct = product.toLowerCase();
  const fileName = `${lowerProduct}_rate_adjustments.csv`;
  return (
    <>
      <Intro>
        You can update existing {lowerProduct.replace(/_/g, '-')} rate adjustments or create new ones by uploading a
        spreadsheet based on this template:{' '}
        <a
          href={`/files/rate_adjustments/${fileName}`}
          className="btn-link"
          target="_blank"
          rel="noopener noreferrer"
          download
        >
          {fileName}
        </a>
      </Intro>
      <FileUploader upload={last(uploads)} />
    </>
  );
};
